/**
 * @generated SignedSource<<150c4e808265f7a7639f1c49f76c8032>>
 * @relayHash 609b875b5bbe29073beb54090634bc95
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/576.0.0-2026-09-09T15:31:58.279Z/NftHeartPillProviderRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftHeartPillProviderRefetchQuery$variables = {
  fetchUser?: boolean | null;
  nftIds?: ReadonlyArray<string> | null;
  userId?: string | null;
};
export type NftHeartPillProviderRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"NftHeartPillProvider_viewer">;
  };
};
export type NftHeartPillProviderRefetchQuery = {
  response: NftHeartPillProviderRefetchQuery$data;
  variables: NftHeartPillProviderRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "fetchUser"
  },
  {
    "defaultValue": "[]",
    "kind": "LocalArgument",
    "name": "nftIds"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "nftIds",
  "variableName": "nftIds"
},
v2 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NftHeartPillProviderRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "fetchUser",
                "variableName": "fetchUser"
              },
              (v1/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "kind": "FragmentSpread",
            "name": "NftHeartPillProvider_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "NftHeartPillProviderRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v1/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "concreteType": "NftItemUserLike",
                "kind": "LinkedField",
                "name": "isNftItemsLikedByUser",
                "plural": true,
                "selections": [
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nftId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isLiked",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/576.0.0-2026-09-09T15:31:58.279Z/NftHeartPillProviderRefetchQuery",
    "metadata": {},
    "name": "NftHeartPillProviderRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "21e43b463ba876673610972092877971";

export default node;
